import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const LongCalendarWithPutsSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.28941 24.6836C4.78295 24.6836 8.64164 22.5188 12.1579 18.0226M33 21.6715C29.5065 21.7232 24.6154 21.9467 19.3917 18.0226" stroke="#A40C0C"
              strokeWidth="2"/>
        <path d="M19.3918 18.0226C17.9399 16.932 16.4622 15.4911 14.981 13.5819C14.0751 15.3143 13.1292 16.7806 12.1579 18.0226" stroke="#089981" strokeWidth="2"/>
    </svg>
)

const LongCalendarWithPuts: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {LongCalendarWithPutsSvg(props)}
    </SvgIcon>
));
export default LongCalendarWithPuts